export interface YearMonth {
  year: string;
  month: string;
}
